import React, { Fragment, useEffect, useState } from "react";
import CommonCard from "../../common/components/CommonCard";
import { Box, Divider, Typography } from "@mui/material";
import CommonButton from "../../common/components/CommonButton";
import theme from "../../theme";
import CommonDialog from "../../common/components/CommonDialog";
import CommonFormField from "../../common/components/CommonFormField";
import moment from "moment";
import { Close } from "@mui/icons-material";
import { showNotification } from "../../common/components/Notification/ToastifyNotification";
import { useDispatch, useSelector } from "react-redux";
import { createReflection, deleteReflection, getReflection, updateReflecation } from "../../api/reflectionApi";
import { setLoading } from "../../features/authSlice";
import { UserTypeId } from "../../common/const";


const Reflection = ({
    fromMentor,
    projectId
}) => {
    const dispatch = useDispatch();
    const { user } = useSelector((state) => state.auth);
    const [deleteOpen, setDeleteOpen] = useState(false);
    const [description, setDescription] = useState(null);
    const [skills, setSkills] = useState(null);
    const [skillList, setSkillList] = useState([]);
    const [relfections, setReflections] = useState([]);
    const [relfectionId, setRelectionId] = useState(null);

    const getReflections = async () => {
        try {
            dispatch(setLoading({
                loading: true
            }));
            const response = await getReflection(projectId);
            setReflections(response?.data);
            dispatch(setLoading({
                loading: false
            }))
        } catch (err) {
            const errorMessage = err.response?.data?.errors?.[0]?.message || err.response?.data?.message || err?.response?.data?.error;
            showNotification(errorMessage, 'error');
            dispatch(setLoading({
                loading: false
            }));
        }
    }

    useEffect(() => {
        if (projectId) {
            getReflections();
        }
    }, [projectId])


    return (
        <Fragment>
            <CommonDialog
                open={deleteOpen}
                size="xs"
                content={(
                    <center>
                        <Typography sx={{ fontWeight: 600, fontSize: '22px', mt: 0.5, mb: 1 }}>
                            Are you sure you want to delete?
                        </Typography>
                    </center>
                )}
                actionButtons={(
                    <Fragment>
                        <CommonButton
                            label="Yes"
                            size="small"
                            background={theme.palette.secondary.main}
                            color={theme.palette.primary.main}
                            handleClick={async () => {
                                try {
                                    dispatch(setLoading({
                                        loading: true
                                    }));
                                    const response = await deleteReflection(relfectionId);
                                    if (response.success) {
                                        showNotification(response.message, 'success');
                                        getReflections();
                                        setRelectionId(null);
                                        setDeleteOpen(false);
                                        dispatch(setLoading({
                                            loading: false
                                        }));
                                    }
                                } catch (err) {
                                    const errorMessage = err.response?.data?.errors?.[0]?.message || err.response?.data?.message || err?.response?.data?.error;
                                    showNotification(errorMessage, 'error');
                                    dispatch(setLoading({
                                        loading: false
                                    }));
                                }
                            }}
                        />
                        <CommonButton
                            label="No"
                            size="small"
                            background={theme.palette.background.main}
                            border={`1px solid ${theme.palette.background.light}`}
                            handleClick={() => {
                                setRelectionId(null);
                                setDeleteOpen(false);
                            }}
                        />
                    </Fragment>
                )}
            />
            <CommonCard
                paddingBottom="0px"
                borderRadius={2}
                content={
                    <Fragment>
                        <Box mb={1}>
                            <Typography fontWeight={600}>Reflection & Learnings</Typography>
                        </Box>
                        <Divider />
                        {!fromMentor && user?.user_type_id === UserTypeId.Student && (
                            <Box mt={1}>
                                <CommonFormField
                                    label="Skills"
                                    type="email"
                                    name="notes"
                                    value={skills}
                                    onChange={(e) => setSkills(e.target.value)}
                                    onKeyDown={(e) => {
                                        if (e.key === 'Enter' && e.target.value.trim() !== '') {
                                            e.preventDefault(); // Prevent form submission if inside a form

                                            const newSkill = e.target.value.trim();

                                            // Check if skill already exists (case-insensitive comparison)
                                            if (skillList.some(skill => skill.toLowerCase() === newSkill.toLowerCase())) {
                                                setSkills(''); // Clear input even if duplicate
                                                return;
                                            }

                                            setSkillList([...skillList, newSkill]);
                                            setSkills(''); // Clear input after adding
                                        }
                                    }}
                                    placeholder="Enter Skills and press Enter"
                                />
                                <Box display="flex" gap={1} mt={1} flexWrap="wrap">
                                    {skillList.length > 0 && skillList.map((skill, index) => (
                                        <Box
                                            key={index}
                                            display="flex"
                                            justifyContent="space-between"
                                            alignItems="center"
                                            gap={1}
                                            sx={{
                                                background: '#DBEAFE',
                                                px: 1,
                                                py: 0.2,
                                                borderRadius: 0.5
                                            }}
                                        >
                                            <Typography fontSize={13} color="#1447E6">{skill}</Typography>
                                            <Close
                                                sx={{ fontSize: 15, color: theme.palette.background.dark, cursor: 'pointer' }}
                                                onClick={() => {
                                                    const updatedList = skillList.filter((_, i) => i !== index);
                                                    setSkillList(updatedList);
                                                }}
                                            />
                                        </Box>
                                    ))}
                                </Box>
                                <Box mt={2}>
                                    <CommonFormField
                                        label="What did you learn this week?"
                                        type="email"
                                        name="notes"
                                        value={description}
                                        onChange={(e) => setDescription(e.target.value)}
                                        placeholder="Write here"
                                        multiline
                                    />
                                </Box>
                                <CommonButton
                                    label="Submit Entry"
                                    marginBottom="0px"
                                    color="White"
                                    background={theme.palette.secondary.main}
                                    marginTop={2}
                                    handleClick={async () => {
                                        try {
                                            if (skillList.length > 0 && description !== null) {
                                                dispatch(setLoading({
                                                    loading: true
                                                }));
                                                let response;
                                                if (relfectionId) {
                                                    response = await updateReflecation(relfectionId, {
                                                        "content": description,
                                                        "skills": skillList
                                                    });
                                                } else {
                                                    response = await createReflection({
                                                        "project_id": projectId,
                                                        "student_id": user?.student_id,
                                                        "content": description,
                                                        "skills": skillList
                                                    });
                                                }
                                                if (response.success) {
                                                    setRelectionId(null);
                                                    showNotification(response.message, 'success');
                                                    getReflections();
                                                    setSkillList([]);
                                                    setDescription('');
                                                    dispatch(setLoading({
                                                        loading: false
                                                    }));
                                                }
                                            } else {
                                                showNotification('Please add skill and description', 'error');
                                            }
                                        } catch (err) {
                                            const errorMessage = err.response?.data?.errors?.[0]?.message || err.response?.data?.message || err?.response?.data?.error;
                                            showNotification(errorMessage, 'error');
                                            dispatch(setLoading({
                                                loading: false
                                            }));
                                        }
                                    }}
                                />
                            </Box>
                        )}
                        {relfections.length > 0  ? relfections.map((a, index) => (
                            <CommonCard
                                key={index}
                                background={theme.palette.background.main}
                                paddingBottom="0px"
                                borderRadius={1}
                                content={
                                    <Box display="flex" alignItems="center" justifyContent="space-between">
                                        <Box>
                                            <Typography fontWeight={600}>{a.content}</Typography>
                                            <Box display="flex" gap={1} mt={1} mb={1}>
                                                {a.skills.map((i, ind) => (
                                                    <Box key={ind} sx={{ background: '#7A869126', p: '2px 10px', borderRadius: 1, border: '1px solid #7A869126' }}>
                                                        <Typography color="#7A8691" fontSize={14}>{i}</Typography>
                                                    </Box>
                                                ))}
                                            </Box>
                                            <Typography fontSize={14} color="background.dark">{`Created on ${moment(a.created_date).format('DD MMM, YYYY')}`}</Typography>
                                        </Box>
                                        {!fromMentor && (
                                            <Box display="flex" gap={1} justifyContent="center">
                                                <CommonButton
                                                    label="Edit"
                                                    color="black"
                                                    background="white"
                                                    height="30px"
                                                    width="50px"
                                                    marginBottom="0px"
                                                    border={`1px solid #0000001A`}
                                                    handleClick={() => {
                                                        setRelectionId(a.reflection_id);
                                                        setDescription(a.content);
                                                        setSkillList(a.skills)
                                                    }}
                                                />
                                                <CommonButton
                                                    label="Delete"
                                                    color="white"
                                                    background="red"
                                                    height="30px"
                                                    width="70px"
                                                    marginBottom="0px"
                                                    handleClick={() => {
                                                        setRelectionId(a.reflection_id);
                                                        setDeleteOpen(true);
                                                    }}
                                                />
                                            </Box>
                                        )}
                                    </Box>
                                }
                            />
                        )) : (
                            <Box p={2}>
                                <Typography  textAlign="center" color={theme.palette.background.dark}>No Data Found</Typography>
                            </Box>
                        )}
                    </Fragment>
                }
            />
        </Fragment>
    )
}

export default Reflection;